import React from 'react';
interface TestimonialCardProps {
  initials: string;
  stars: number;
  quote: string;
  name: string;
  location: string;
  level: string;
}
function TestimonialCard({
  initials,
  stars,
  quote,
  name,
  location,
  level
}: TestimonialCardProps) {
  return <div className="bg-black border border-[#00C853]/30 rounded-2xl p-6 flex flex-col gap-4" data-id="element-382">
      <div className="flex items-center gap-3" data-id="element-383">
        <div className="w-12 h-12 rounded-full bg-[#00C853]/20 border border-[#00C853]/40 flex items-center justify-center text-[#00C853] font-black text-sm flex-shrink-0" data-id="element-384">
          {initials}
        </div>
        <div data-id="element-385">
          <div className="text-[#00C853] text-sm" data-id="element-386">{'⭐'.repeat(stars)}</div>
          <div className="text-white font-bold text-sm" data-id="element-387">{name}</div>
          <div className="text-gray-400 text-xs" data-id="element-388">
            📍 {location} | {level}
          </div>
        </div>
      </div>
      <p className="text-gray-300 text-sm leading-relaxed italic" data-id="element-389">"{quote}"</p>
    </div>;
}
export function TestimonialsSection() {
  return <section className="w-full bg-[#0a0a0a] py-16 px-4" data-id="element-390">
      <div className="max-w-5xl mx-auto" data-id="element-391">
        <h2 className="text-3xl sm:text-4xl font-black text-white text-center mb-4" data-id="element-392">
          Más testimonios de profes que ya lo usan
          <br data-id="element-393" />
          <span className="text-[#00C853]" data-id="element-394">que ya tienen su MegaPack:</span>
        </h2>
        <p className="text-gray-400 text-center mb-10" data-id="element-395">
          +500 profes de Argentina ya lo usan
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 gap-5" data-id="element-396">
          <TestimonialCard initials="FL" stars={5} quote="Lo que más valoro es que está organizado por edad real del Baby Fútbol argentino. Mis pibes de 10 años finalmente entienden el sistema. El Tomo 4 con el rombo y las transiciones es extraordinario." name="Fernando L." location="Tucumán" level="DT Baby Fútbol" data-id="element-397" />
          <TestimonialCard initials="VT" stars={5} quote="Tengo grupos muy numerosos y poco tiempo. El Bono 3 de Sin Filas Sin Caos me cambió la vida. Los 20 códigos de voz son algo que no sabía que necesitaba hasta que los usé." name="Valentina T." location="Santa Fe" level="Profe de Ed. Física" data-id="element-398" />
          <TestimonialCard initials="PA" stars={5} quote="La primera vez que entregué el informe de progreso a los padres... fue la primera vez en años que un padre me agradeció en vez de quejarse. Vale el pack solo por eso." name="Pablo A." location="Neuquén" level="DT Baby Fútbol Club de Barrio" data-id="element-399" />
          <TestimonialCard initials="SC" stars={5} quote="Tenía miedo de que fuera material genérico. Cuando abrí el Tomo 1 encontré exactamente lo que le falta al pibe argentino: sin filas, pelota en los pies desde el minuto 1. Mis pibes de 4 años terminan la clase sin querer irse." name="Santiago C." location="La Plata" level="Escuelita de Fútbol" data-id="element-400" />
        </div>
      </div>
    </section>;
}